import type { GridCustomCellProps } from "@tql/ui-components-react/kendo/grid";

import { GridTd } from "~/shared/components/trax-grid/grid-td/grid-td.tsx";
import { InvoiceStatusBadge } from "~/shared/components/trax-grid/invoice-status-badge/invoice-status-badge.tsx";
import type { Invoice } from "~/shared/schemas/invoice-schema";

type InvoiceStatusCellProps = Omit<GridCustomCellProps, "dataItem"> & {
	dataItem: Invoice;
};

export const InvoiceStatusCell = (props: InvoiceStatusCellProps) => {
	const { dataItem } = props;

	return (
		<GridTd
			className={`invoice-status-cell ${props.tdProps?.className ?? ""}`}
			tdProps={props.tdProps}
		>
			<InvoiceStatusBadge invoice={dataItem} />
		</GridTd>
	);
};
